import React, { useEffect, useState } from "react";
import { CirclePlay } from "lucide-react";
import { api } from "@/lib/api";
import { colonyApi } from "@/lib/colonyApi";
import { Button } from "@/components/ui/button";
import { TutorialDialog } from "./TutorialDialog";
import { t as T } from "@/lib/i18n";
import { selectWorkerTutorial } from "@/lib/tutorialLanguages";

const availability = {};
export const resetTutorialAvailability = () => { Object.keys(availability).forEach(key => delete availability[key]); };
const loadAvailability = audience => {
  // Worker and worker-manager accounts share the audience but have different
  // permitted sections. Fetch anew on mount/role change, not across accounts.
  if (audience === "worker") return api.get("/tutorials/worker")
    .then(({ data }) => new Set(data.available)).catch(() => new Set());
  if (!availability[audience]) {
    const client = audience === "colony" ? colonyApi : api;
    availability[audience] = client.get(`/tutorials/${audience}`).then(({ data }) => new Set(data.available))
      .catch(() => { delete availability[audience]; return new Set(); });
  }
  return availability[audience];
};

export const TutorialButton = ({ section, audience = "admin", language = "en", compact = false, className = "" }) => {
  const [open, setOpen] = useState(false);
  const [sections, setSections] = useState(new Set());
  useEffect(() => {
    let cancelled = false;
    setSections(new Set());
    loadAvailability(audience).then(set => { if (!cancelled) setSections(set); });
    return () => { cancelled = true; };
  }, [audience, section, language]);
  const selectedSection = audience === "worker" ? selectWorkerTutorial(section, language, sections)
    : sections.has(section) ? section : null;
  if (!selectedSection) return null;
  return <>
    <Button type="button" variant="outline" size="sm" className={`tutorial-button shrink-0 font-normal ${compact ? "tutorial-button-compact h-5 px-1.5 gap-1 text-[10px] rounded" : className || "h-7 px-2.5 gap-1.5 text-xs rounded-md"}`} onClick={() => setOpen(true)} data-testid={`tutorial-open-${audience}-${section}`} data-tutorial-section={selectedSection}><CirclePlay className={compact ? "!h-3 !w-3" : "h-3.5 w-3.5"} />{T("Watch tutorial")}</Button>
    {open && <TutorialDialog key={selectedSection} section={selectedSection} audience={audience} open={open} onOpenChange={setOpen} />}
  </>;
};
